import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ACHIEVEMENTS } from '@env';

@Injectable()
export class AchievementProvider {

  constructor(public http: HttpClient) {
  }

  getAll(area: string, equipo: string, jugador: string): Promise<any> {
    return this.http.get( `${ACHIEVEMENTS.LISTA}${area}/${equipo}/${jugador}` ).toPromise();
  }

  verificaNuevasInsignias(area: string, equipo: string, jugador: string): Promise<any> {
    return this.http.get( `${ACHIEVEMENTS.NUEVOS_LOGROS}${area}/${equipo}/${jugador}` ).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/achievement/achievement.ts